var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.933333C0 0.417868 0.417868 0 0.933333 0H23.5822C23.8298 0 24.0672 0.098333 24.2422 0.273367L27.7266 3.75781C27.9017 3.93285 28 4.17024 28 4.41778V19.1333C28 19.6488 27.5821 20.0667 27.0667 20.0667C26.5512 20.0667 26.1333 19.6488 26.1333 19.1333V4.80438L23.1956 1.86667H1.86667V26.1333H11.2C11.7155 26.1333 12.1333 26.5512 12.1333 27.0667C12.1333 27.5821 11.7155 28 11.2 28H0.933333C0.417868 28 0 27.5821 0 27.0667V0.933333Z",
    fill: "#58486C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8396 0C22.355 0 22.7729 0.417868 22.7729 0.933333V5.22667H27.0663C27.5817 5.22667 27.9996 5.64453 27.9996 6.16C27.9996 6.67547 27.5817 7.09333 27.0663 7.09333H21.8396C21.3241 7.09333 20.9062 6.67547 20.9062 6.16V0.933333C20.9062 0.417868 21.3241 0 21.8396 0Z",
    fill: "#58486C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1333 12.1342C15.2673 12.1342 12.1333 15.2683 12.1333 19.1342C12.1333 23.0002 15.2673 26.1342 19.1333 26.1342C22.9993 26.1342 26.1333 23.0002 26.1333 19.1342C26.1333 18.6188 26.5511 18.2009 27.0666 18.2009C27.5821 18.2009 27.9999 18.6188 27.9999 19.1342C27.9999 24.0312 24.0302 28.0009 19.1333 28.0009C14.2363 28.0009 10.2666 24.0312 10.2666 19.1342C10.2666 14.2373 14.2363 10.2676 19.1333 10.2676C19.6487 10.2676 20.0666 10.6854 20.0666 11.2009C20.0666 11.7164 19.6487 12.1342 19.1333 12.1342Z",
    fill: "#58486C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1766 10.4932C21.5522 10.8462 21.5705 11.4369 21.2174 11.8125L19.4093 13.7359C19.0562 14.1115 18.4655 14.1297 18.09 13.7766C17.7144 13.4236 17.6961 12.8329 18.0492 12.4573L19.2181 11.2139L17.9747 10.0451C17.5991 9.69203 17.5809 9.10136 17.9339 8.72578C18.287 8.35021 18.8776 8.33196 19.2532 8.68502L21.1766 10.4932Z",
    fill: "#58486C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6671 15.8672C18.1516 15.8672 17.7338 16.2851 17.7338 16.8005V20.5339C17.7338 20.8573 17.9013 21.1577 18.1764 21.3278C18.4516 21.4979 18.7952 21.5133 19.0845 21.3687L22.8178 19.502C23.2789 19.2715 23.4658 18.7108 23.2352 18.2498C23.0047 17.7887 22.4441 17.6019 21.983 17.8324L19.6004 19.0237V16.8005C19.6004 16.2851 19.1826 15.8672 18.6671 15.8672Z",
    fill: "#58486C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7334 5.59935C3.7334 5.08388 4.15127 4.66602 4.66673 4.66602H14.9334C15.4489 4.66602 15.8667 5.08388 15.8667 5.59935C15.8667 6.11481 15.4489 6.53268 14.9334 6.53268H4.66673C4.15127 6.53268 3.7334 6.11481 3.7334 5.59935Z",
    fill: "#58486C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.7334 9.33372C3.7334 8.81826 4.15127 8.40039 4.66673 8.40039H10.2667C10.7822 8.40039 11.2001 8.81826 11.2001 9.33372C11.2001 9.84919 10.7822 10.2671 10.2667 10.2671H4.66673C4.15127 10.2671 3.7334 9.84919 3.7334 9.33372Z",
    fill: "#58486C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.5e9b80bf940a40b51e40a9092c61a34b.svg";
export { ForwardRef as ReactComponent };